import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

export const onUploadedAndFileAssociated = (
	tMipManage: ReturnType<typeof useTranslationMipManage>,
	getKYCDataRequest: { refetch: () => void }
) => {
	return () => {
		showToastV2({ title: tMipManage('investors.success') });
		getKYCDataRequest.refetch();
	};
};
